import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';

const ProtectedRoute = ({ children, requiredPermission, requiredModule }) => {
  const { hasPermission, hasModule, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    toast.error('Access Denied: You lack permissions for this page');
    return <Navigate to="/dashboard" replace />;
  }

  if (requiredModule && !hasModule(requiredModule)) {
    toast.error(`This app is not in your subscription. Enable "${requiredModule.toUpperCase()}" under Settings → Apps.`);
    return <Navigate to="/settings/subscription/plans" replace />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
